import clsx from 'clsx'

import s from './Textarea.module.scss'
import type { TextareaProps } from './Textarea.props'

export function Textarea({ className, ...props }: TextareaProps) {
  return (
    <textarea
      className={clsx(s.textarea, className)}
      rows={5}
      {...props}
    />
  )
}
